// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__QOv5H","wrapperImg":"style_wrapperImg__ZufHu"};